.output {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    line-height: 1;
}

.output label {
    font-family: var(--font-table-heading);
    font-weight: bold;
}

.output output {
    min-height: 1em;
    text-align: center;
    margin-bottom: 0.125em;
}